import React, { Component } from 'react';
import '../CSS/navBar.css';
import '../CSS/styles.css';
import { Link, NavLink } from 'react-router-dom';

const navLinkClassName = ({ isActive }) =>
  isActive ? 'nav-link active' : 'nav-link';

// fixed - top;
class NavBar extends Component {
  render() {
    return (
      <header className='site-header'>
        <nav className='navbar navbar-expand-lg navbar-light'>
          <div className='container'>
            <Link className='titleStyle navbar-brand' to='/'>
              Benjamin Anoh
            </Link>
            <button
              className='navbar-toggler'
              type='button'
              data-bs-toggle='collapse'
              data-bs-target='#navbarCollapse'
              aria-controls='navbarCollapse'
              aria-expanded='false'
              aria-label='Toggle navigation'>
              <span className='navbar-toggler-icon'></span>
            </button>
            <div
              className='container collapse navbar-collapse'
              id='navbarCollapse'>
              <div className='ms-auto text-lg-end'>
                <ul className='navbar-nav mb-2 mb-md-0'>
                  <li className='nav-item'>
                    <NavLink className={navLinkClassName} to='/portrait'>
                      Photography
                    </NavLink>
                  </li>
                  <li className='nav-item'>
                    <NavLink className={navLinkClassName} to='/apps'>
                      Apps
                    </NavLink>
                  </li>
                  <li className='nav-item'>
                    <NavLink className={navLinkClassName} to='/' end>
                      Contact
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </header>
    );
  }
}
export default NavBar;
